import packageJson from "../../package.json";
import { Environment } from "./environment.interface";

export const environment: Environment = {
  production: true,
  name: "tribuna",
  version: packageJson.version,
};
